var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountProyectoInactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#C03636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8731 10.0346L12.3781 10.9785C12.2073 11.0861 12.2073 11.3202 12.3781 11.4284L13.8731 12.3722C13.972 12.4349 14.1026 12.4349 14.2015 12.3722L15.6965 11.4284C15.8673 11.3207 15.8673 11.0866 15.6965 10.9785L14.2015 10.0346C14.1026 9.97196 13.972 9.97196 13.8731 10.0346Z",
    fill: "#C03636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3777 20L14.3448 18.5183L16.8888 17.0847L17.8405 20H10.104L11.0688 17.0695L13.6253 18.4946L10.644 20H17.3777Z",
    fill: "#C03636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6575 16.7995C16.6651 16.8086 16.6776 16.9022 16.6254 16.8981L14.0057 18.2802L11.3633 16.8693L14.0014 14.9893L16.6575 16.7995Z",
    fill: "#C03636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4941 8.72332L13.9848 7L15.476 8.72332H12.4941Z",
    fill: "#C03636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 9.08022V10.6569H9.021L12.0017 9.08022Z",
    fill: "#C03636"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.019 9.08022V10.6569H18.9998L16.019 9.08022Z",
    fill: "#C03636"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9807 11.6382V13.2149H9L11.9807 11.6382Z",
    fill: "#C03636"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 11.6382V13.2149H18.9788L15.998 11.6382Z",
    fill: "#C03636"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7273 14.7451L11.3633 16.4164L12.1861 13.7881L13.7273 14.7451Z",
    fill: "#C03636"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.783 13.7887L16.6575 16.4164L14.2549 14.7335L15.783 13.7887Z",
    fill: "#C03636"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2886 9.15353L13.6258 9.89361L12.2886 10.5872V9.15353Z",
    fill: "#C03636"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2886 13.2149V11.7817L13.6253 12.4748L12.2886 13.2149Z",
    fill: "#C03636"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6815 11.7817V13.2149L14.3447 12.4748L15.6815 11.7817Z",
    fill: "#C03636"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6815 9.15353V10.5872L14.3447 9.82334L15.6815 9.15353Z",
    fill: "#C03636"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2185 9.01046L14.0106 9.67775C13.6017 9.47301 13.1633 9.28344 12.8022 9.01046H15.2179H15.2185Z",
    fill: "#C03636"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9293 13.7836L13.9033 14.3983C13.9681 14.4393 14.0529 14.4393 14.1176 14.3983L15.0916 13.7836C15.146 13.7492 15.1737 13.6946 15.1748 13.64H12.8467C12.8478 13.6946 12.875 13.7492 12.9299 13.7836H12.9293Z",
    fill: "#C03636"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0912 13.4181L14.1172 12.8034C14.0525 12.7624 13.9676 12.7624 13.9029 12.8034L12.9289 13.4181C12.8745 13.4525 12.8468 13.5071 12.8457 13.5617H15.1738C15.1727 13.5071 15.1456 13.4525 15.0906 13.4181H15.0912Z",
    fill: "#C03636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountProyectoInactivo);
export default __webpack_public_path__ + "static/media/countProyectoInactivo.fe8a88e568ca6bdcecd00575d16dae12.svg";
export { ForwardRef as ReactComponent };